import React from "react";

import { StyledFeature, StyledImage, StyledTitle } from "./style";

const Feature = ({ image, title }) => (
  <StyledFeature>
    <StyledImage src={image} />
    <StyledTitle variant="label2">{title}</StyledTitle>
  </StyledFeature>
);

export default Feature;
